import { permission } from './permission/index';

export default {
  install(app: TypeObject): void {
    app.directive('permission', permission);
  },
};
